let cache

export const setCache = lib => {
  cache = lib
}

export default {
  get cache () {
    return cache
  }
}
